// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","content":"Header_content__8sQm-","logo":"Header_logo__shVBB","menu":"Header_menu__iSxy+"};